import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { skiPassAPI } from '../services/api';

const SkiPasses = () => {
  const [skiPasses, setSkiPasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchSkiPasses();
  }, []);

  const fetchSkiPasses = async () => {
    try {
      setLoading(true);
      const response = await skiPassAPI.getAllSkiPasses();
      setSkiPasses(response.data);
      setError('');
    } catch (err) {
      setError('Не вдалося завантажити паси. Переконайтеся, що сервер запущено.');
      console.error('Error fetching ski passes:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Ви впевнені, що хочете видалити цей пас?')) {
      try {
        await skiPassAPI.deleteSkiPass(id);
        setSkiPasses(skiPasses.filter(pass => pass._id !== id));
      } catch (err) {
        setError('Не вдалося видалити пас');
        console.error('Error deleting ski pass:', err);
      }
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  const getPassTypeUkrainian = (passType) => {
    const translations = {
      'day': 'Денний пас',
      'week': 'Тижневий пас',
      'season': 'Сезонний пас',
      'half-day': 'Пів дня'
    };
    return translations[passType] || passType;
  };

  if (loading) {
    return <div className="skipass-loading">Завантаження пасів...</div>;
  }

  return (
    <div>
      <div className="skipass-page-header">
        <Link to="/" className="skipass-back-link">← Назад до тарифів</Link>
        <h1>Мої SKI Паси</h1>
        <div className="skipass-simple-nav">
          <Link to="/add" className="skipass-nav-btn">Купити Пас</Link>
        </div>
      </div>
      
      {error && <div className="skipass-error">{error}</div>}
      
      {skiPasses.length === 0 ? (
        <div className="skipass-pricing-section">
          <p>Паси не знайдено. <a href="/add">Купити перший пас</a></p>
        </div>
      ) : (
        <div className="skipass-pricing-grid">
          {skiPasses.map((pass) => (
            <div key={pass._id} className="skipass-pricing-card">
              <div className="skipass-card-header">
                <div>
                  <div className="skipass-pass-type">{pass.holderName}</div>
                  <div className="skipass-pass-duration">{getPassTypeUkrainian(pass.passType)}</div>
                </div>
                <div className="skipass-card-price">
                  <div className="skipass-card-price-amount">{pass.price} ₴</div>
                </div>
              </div>
              
              <div className="skipass-ski-pass-info">
                <div className="skipass-info-item">
                  <div className="skipass-info-label">Курорт</div>
                  <div className="skipass-info-value">{pass.resort}</div>
                </div>
                
                <div className="skipass-info-item">
                  <div className="skipass-info-label">Дійсний з</div>
                  <div className="skipass-info-value">{formatDate(pass.validFrom)}</div>
                </div>
                
                <div className="skipass-info-item">
                  <div className="skipass-info-label">Дійсний до</div>
                  <div className="skipass-info-value">{formatDate(pass.validUntil)}</div>
                </div>
                
                <div className="skipass-info-item">
                  <div className="skipass-info-label">Статус</div>
                  <div className="skipass-info-value">
                    <span style={{ 
                      color: pass.isActive ? '#27ae60' : '#e74c3c',
                      fontWeight: 'bold'
                    }}>
                      {pass.isActive ? 'Активний' : 'Неактивний'}
                    </span>
                  </div>
                </div>
              </div>
              
              <div style={{ marginTop: '15px' }}>
                <button 
                  className="skipass-btn skipass-btn-danger"
                  onClick={() => handleDelete(pass._id)}
                >
                  Видалити
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SkiPasses;
